import { translatedNames } from 'constants/routes';
import { ContentRoutes } from 'enums/routes';
import { MethodTypes } from 'enums/types';

export default [
  {
    items: [
      {
        label: 'Dashboard',
        icon: 'chart-pie',
        pathname: '/dashboard',
        policy: `dashboard.${MethodTypes.View}`,
      }, {
        label: 'Empresas',
        icon: 'briefcase',
        pathname: '/table/companies',
        policy: `company.${MethodTypes.SuperUser}`,
      },
      {
        label: 'Projetos',
        icon: 'project-diagram',
        pathname: `/table/${ContentRoutes.Project}`,
        policy: `projects.${MethodTypes.View}`,
      },
      {
        label: 'QrCodes',
        icon: 'qrcode',
        pathname: `/table/${ContentRoutes.QRCode}`,
        policy: `materials.${MethodTypes.View}`,
      },
    ],
  },
  {
    label: 'OPERAÇÕES',
    items: [
      {
        label: [translatedNames[ContentRoutes.Routes]],
        icon: 'random',
        pathname: `/table/${ContentRoutes.Routes}`,
        policy: `routes.${MethodTypes.View}`,
      },
      {
        label: 'Cargas',
        icon: 'vial',
        options: [
          {
            label: 'Materiais',
            pathname: `/table/${ContentRoutes.Materials}`,
            policy: `materials.${MethodTypes.View}`,

          },
          {
            label: 'Embalagens',
            pathname: `/table/${ContentRoutes.Containers}`,
            policy: `containers.${MethodTypes.View}`,
          },
        ],
      },
      {
        label: 'Frota',
        icon: 'truck',
        options: [
          {
            label: 'Veículos',
            pathname: `/table/${ContentRoutes.Vehicles}`,
            policy: `vehicles.${MethodTypes.View}`,
          },
          {
            label: 'Acessórios Veículares',
            pathname: `/table/${ContentRoutes.AccessoryTypes}`,
            policy: `vehicles.${MethodTypes.View}`,
          },
        ],
      },
      {
        label: 'Condutores',
        icon: 'id-card',
        pathname: '/table/drivers',
        policy: `drivers.${MethodTypes.View}`,
      },
      {
        label: 'Despacho',
        icon: 'plane',
        pathname: `/table/${ContentRoutes.Dispatch}`,
        policy: `routes.${MethodTypes.View}`,
      },
      {
        label: 'Regionais',
        icon: 'map-marker-alt',
        pathname: `/table/${ContentRoutes.Regionals}`,
        policy: `regionals.${MethodTypes.View}`,
      },
    ],
  },
  {
    label: 'PESSOAS',
    items: [
      {
        label: 'Parceiros',
        icon: 'handshake',
        pathname: '/table/partners',
        policy: `partners.${MethodTypes.View}`,
      }, {
        label: translatedNames[ContentRoutes.Users],
        icon: 'users',
        options: [
          {
            label: translatedNames[ContentRoutes.Users],
            pathname: `/table/${ContentRoutes.Users}`,
            policy: `users.${MethodTypes.View}`,
          },
          {
            label: translatedNames[ContentRoutes.SuperUsers],
            pathname: `/table/${ContentRoutes.SuperUsers}`,
            policy: `users.${MethodTypes.SuperUser}`,
          },
          {
            label: translatedNames[ContentRoutes.Roles],
            pathname: `/table/${ContentRoutes.Roles}`,
            policy: `roles.${MethodTypes.View}`,
          },
        ],
      },
    ],
  }, {
    label: 'AÇÕES',
    items: [
      {
        label: translatedNames[ContentRoutes.Checklists],
        icon: 'tasks',
        pathname: `/table/${ContentRoutes.Checklists}`,
        policy: `checklists.${MethodTypes.View}`,
      },
      {
        label: translatedNames[ContentRoutes.Trainings],
        icon: 'users-class',
        options: [
          {
            label: 'Todos os '.concat(translatedNames[ContentRoutes.Trainings]),
            pathname: `/table/${ContentRoutes.Trainings}`,
            policy: `training.${MethodTypes.View}`,
          },
          {
            label: 'Meus '.concat(translatedNames[ContentRoutes.Trainings]),
            pathname: `/table/users/${ContentRoutes.Trainings}`,
          },
        ],
      },
    ],
  },
];
